import { gql } from "@apollo/client";
import Grid from "atoms/Grid";
import useData from "helpers/useData";
import Message from "molecules/Message";
import Section from "molecules/Section";
import React from "react";

import ReelCard, { ReelCardFragment } from "./ReelCard";

export const GameOverviewReelsFragment = gql`
  fragment GameOverviewReelsFragment on Game {
    id
  }
`;

export const GameOverviewReelsGamePlayerFragment = gql`
  fragment GameOverviewReelsGamePlayerFragment on GamePlayer {
    person {
      id
      fullNameWithAnonymisation
    }
  }
`;

export default function GameOverviewReels({ gamePlayer }) {
  const [data] = useData(
    gql`
      query GameOverviewReels($gamePlayerId: ID!) {
        gamePlayer(id: $gamePlayerId) {
          id
          reelViews {
            id
            ...ReelCardFragment
          }
        }
      }
      ${ReelCardFragment}
    `,
    {
      gamePlayerId: gamePlayer?.id,
    },
    {
      skip: !gamePlayer,
    },
  );

  return (
    <Section title={`${gamePlayer?.person.fullNameWithAnonymisation}'s Highlight Reels`}>
      {data?.gamePlayer.reelViews.length === 0 && (
        <Message>No reels yet! Start tagging events to create your first reel.</Message>
      )}
      <Grid gridItemWidth="250px">
        {data?.gamePlayer.reelViews.map((reelView) => (
          <ReelCard key={reelView.id} reelView={reelView} />
        ))}
      </Grid>
    </Section>
  );
}
